<template>
  <div class="content Tabs">

    <b-tabs card>
      <b-tab :title="lang.tab_Tasks"  :title-link-class="textColors" :title-item-class="textColors"  active >

        <TasksComponent :lang="lang.Tasks" parent="details"></TasksComponent>
      </b-tab>
      <b-tab :title="lang.tab_WhereUse"  :title-link-class="textColors" :title-item-class="textColors" >
        <span v-if="appConf.status.isPRM">
          <WhereUseTableComponent  :parent="'parts'"  :lang="lang.WhereUse"></WhereUseTableComponent>
          <br>
        </span>
        <WhatIsIncludedForPartsComponent :parent="'parts'" v-if="selectedRows.length == 1" :lang="lang.WhatIsIncluded"></WhatIsIncludedForPartsComponent>
      </b-tab>
      <b-tab :title="lang.tab_Alternatives" :title-link-class="textColors" :title-item-class="textColors"  >
        
          <div v-if="selectedRows.length != 1">
              <p>{{lang.infotext_3}}</p>
          </div>
          <AlternativesTableComponent  :parent="'partdetails'" v-show="!isAlternativeSelected"  v-if="selectedRows.length == 1" :lang="lang.Alternatives" ></AlternativesTableComponent>
          <div v-if="isAlternativeSelected">
            <AlternativeDetailsComponent   :lang="lang.AlternativeDetails"></AlternativeDetailsComponent>
          </div>
        </b-tab>
        <b-tab :title="lang.tab_Pins" :title-link-class="textColors" :title-item-class="textColors">
            <div v-if="selectedRows.length != 1">
                  <p>{{ lang.infotext_5 }}</p>
              </div>
              <span v-if="!isNoEmptyLibraries && selectedRows.length == 1">
                <p v-if="selectedRows.length == 1">{{ lang.infotext_6 }}:</p>
                <b-button  class="btn analyze-button" size="sm" :variant="variant" @click="analyzePins">
                    {{ lang.button_Analyze }}
                </b-button>
                <br><br>
              </span>
              <p v-if="selectedRows.length == 1">{{ lang.infotext_7 }}:</p>

            <PinsPartsSymbolComponent v-if="selectedRows.length == 1" :lang="lang.PinsPartsTable" parent="PartTable"></PinsPartsSymbolComponent>

            <PinsPartsHDLSymbolComponent v-if="selectedRows.length == 1" :lang="lang.PinsPartsTable" parent="PartTable"></PinsPartsHDLSymbolComponent>

            <PinsPartsFootprintComponent v-if="selectedRows.length == 1" :lang="lang.PinsPartsTable" parent="PartTable"></PinsPartsFootprintComponent>
          </b-tab>
    </b-tabs>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import TasksComponent from '@/components/shared/TasksComponent'
import WhereUseTableComponent from '@/components/shared/WhereUseTableComponent'
import AlternativesTableComponent from '@/components/shared/AlternativesTableComponent'
import AlternativeDetailsComponent from '@/components/shared/AlternativeDetailsComponent'
import WhatIsIncludedForPartsComponent from '@/components/shared/WhatIsIncludedForPartsComponent'
import PinsPartsSymbolComponent from '@/components/shared/PinsPartsSymbolComponent'
import PinsPartsHDLSymbolComponent from '@/components/shared/PinsPartsHDLSymbolComponent'
import PinsPartsFootprintComponent from '@/components/shared/PinsPartsFootprintComponent'

export default {
  name: "Content",
  components: {
    TasksComponent,
    WhereUseTableComponent,
    AlternativesTableComponent,
    AlternativeDetailsComponent,
    WhatIsIncludedForPartsComponent,
    PinsPartsSymbolComponent,
    PinsPartsHDLSymbolComponent,
    PinsPartsFootprintComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      isNoEmptyLibraries: false
      
    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      appConf: 'appConf',
    }),
    isAlternativeSelected(){
      return this.$store.getters.selectedAlternative.distributorPartId != undefined;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    },
  },
  methods: {
    analyzePins() {


      const data = {

      }

      let func = function () {

      }

      const obj = {
        title: this.lang.modal_title_modal_PinAnalysis,
        text: "",
        type: "pinAnalysis",
        buttons: 1,
        buttonName: "Close",
        size: "xl",
        lang: this.lang.modal_PinAnalysis,
        funcNo: "",
        funcYes: "",
        funcCustom: func,
        data: data
      };
      this.$store.dispatch("showModalComponent", obj);
    },
  }
}
</script>

<style scooped>

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartDetails/Right/Content/Content.vue